import { render, staticRenderFns } from "./PersonalHeader.vue?vue&type=template&id=7dcdc609&scoped=true&"
import script from "./PersonalHeader.vue?vue&type=script&lang=ts&"
export * from "./PersonalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalHeader.vue?vue&type=style&index=0&id=7dcdc609&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcdc609",
  null
  
)

export default component.exports